export default {
    title: 'title',
    vat_id: 'الرقم الضريبي',
    cr_id: 'رقم السجل التجاري',
};
